import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngxs/store";
import { SignInRedirect } from "@store/auth/auth.actions";
import { AuthSelectors } from "@store/auth/auth.selectors";
import { map } from "rxjs";

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  if (state.url.includes('consultation/start') || state.url.includes('consultation/active')) {
    return true;
  }
  return store.select(AuthSelectors.isLoggedIn).pipe(
    map((isLoggedIn) => {
      if (isLoggedIn) {
        return true;
      } else {
        store.dispatch(new SignInRedirect());
        return false;
      }
    })
  );
};